// SubAgentsListPage.tsx 
import type { SubAgentRow } from "../store/get-subagents.slice";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import PageHeader from "../../shared-components/page-header/PageHeader";
import { useHistory, useRouteMatch } from "react-router-dom";
import { AppState } from "app/store";
import { getSubAgents } from "../store/get-subagents.slice";
import LoadingTableRow from "../../shared-components/base-table/LoadingTableRow";
import { Table, TableHead, TableRow, TableCell, TableBody } from "@material-ui/core";
import { useTranslation } from "react-i18next";

const SubAgentsListPage = () => {
  const match = useRouteMatch<{ id: string }>();
  const agentId = match?.params.id ?? "";

  const dispatch = useDispatch();
  const history = useHistory();
  const { t } = useTranslation();

  const { loading, rows } = useSelector((s: AppState) => s.agents.subAgents);

  useEffect(() => {
    // @ts-ignore if using plain Dispatch
    if (agentId) dispatch(getSubAgents(agentId));
  }, [dispatch, agentId]);

  return (
    <div>
      <PageHeader
        title={t(
          "app.main.agents.subAgentsList.title",
          "Sub-Agents"
        )}
        desc={t(
          "app.main.agents.subAgentsList.description",
          "All sub-agents for this agent"
        )}
        backButton={() => history.goBack()}
      />

      <Table>
        <TableHead>
          <TableRow>
            <TableCell>
              {t(
                "app.main.agents.subAgentsList.columns.fullName",
                "Full name"
              )}
            </TableCell>
            <TableCell>
              {t(
                "app.main.agents.subAgentsList.columns.email",
                "Email"
              )}
            </TableCell>
            <TableCell>
              {t(
                "app.main.agents.subAgentsList.columns.phone",
                "Phone"
              )}
            </TableCell>
            <TableCell>
              {t(
                "app.main.agents.subAgentsList.columns.status",
                "Status"
              )}
            </TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {loading && <LoadingTableRow colSpan={4} />}

          {!loading &&
            rows.map((r: SubAgentRow) => (
              <TableRow key={r.id}>
                <TableCell>{r.fullName}</TableCell>
                <TableCell>{r.email}</TableCell>
                <TableCell>{r.phoneNumber}</TableCell>
                <TableCell>
                  {r.status
                    ? t(
                        "app.main.agents.subAgentsList.status.active",
                        "Active"
                      )
                    : t(
                        "app.main.agents.subAgentsList.status.disabled",
                        "Disabled"
                      )}
                </TableCell>
              </TableRow>
            ))}

          {!loading && rows.length === 0 && (
            <TableRow>
              <TableCell colSpan={4}>
                {t(
                  "app.main.agents.subAgentsList.noData",
                  "No sub-agents found."
                )}
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </div>
  );
};

export default SubAgentsListPage;
